import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Breadcrumb, Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { HealthcareEntityService, HealthcareFacility } from '../../api';
import { Card } from '../../app/components/Card';
import { useDocumentTitle } from '../../app/hooks/use-document-title';
import { healthcareEntityFacilityQueryKeys } from '../../app/query-keys-factories/facilities';
import { FacilityForm } from './FacilityForm';

export const FacilityCreate = () => {
  useDocumentTitle('Create Facility');
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const mutationCreateFacility = useMutation({
    mutationFn: async (data: HealthcareFacility) =>
      await HealthcareEntityService.healthcareEntityFacilitiesCreate({ requestBody: data }),
    onSuccess: () => {
      queryClient.invalidateQueries(healthcareEntityFacilityQueryKeys.allLists());
      navigate('/app/healthcare-entity/facilities');
    },
  });
  return (
    <div>
      <div className="bg-primary-dark">
        <Container className="pt-3 pb-1">
          <Breadcrumb className="breadcrumb-bg-primary-dark">
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/app/healthcare-entity/facilities' }}>
              Facilities List
            </Breadcrumb.Item>
            <Breadcrumb.Item
              linkAs={Link}
              linkProps={{ to: '/app/healthcare-entity/facilities/new' }}
              active
            >
              New Facility
            </Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>
      <div className="bg-primary-dark">
        <Container className="page-header-title py-2">
          <h1>New Facility</h1>
        </Container>
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="bg-primary-dark d-block"
          style={{
            height: '110px',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            zIndex: -10,
          }}
        />
        <Container>
          <Card className="p-4 mb-4">
            <FacilityForm
              mutation={mutationCreateFacility}
              successMessage="Facility created successfully"
            />
          </Card>
        </Container>
      </div>
    </div>
  );
};
